import {createFormActionTypes} from "../../../../../shared/ts/helpers/create_form_action_types";
import {createFormActions} from "../../../../../shared/ts/helpers/create_form_actions";

export const REEL_FILTER_PREFIX = "reel/filter_list";
export const filterReelListFormTypes = createFormActionTypes(REEL_FILTER_PREFIX);
export const filterReelListFormActions = createFormActions(filterReelListFormTypes);
